import { FC, memo } from 'react'
import { createIcon, IconProps } from '@chakra-ui/icons'

import CustomIcon from '../../CustomIcon'

const CheckCircleIcon = createIcon({
  displayName: 'CheckCircleIcon',
  viewBox: '0 0 24 24',
  path: (
    <>
      <g
        xmlns="http://www.w3.org/2000/svg"
        strokeLinecap="round"
        strokeWidth="1.5"
        stroke="currentColor"
        fill="none"
        strokeLinejoin="round"
      >
        <path d="M12 3a9 9 0 1 0 0 18 9 9 0 1 0 0-18Z" />
        <path d="M8.44 12.339l2.167 2.167 -.02-.02 4.88-4.89" />
      </g>
      <path xmlns="http://www.w3.org/2000/svg" fill="none" d="M0 0h24v24H0Z" />
    </>
  ),
})

const CheckCircle: FC<IconProps> = (props) => {
  return <CustomIcon as={CheckCircleIcon} {...props} />
}

export default memo(CheckCircle)
